export const PHONE_PREFIXES = [
	{
		id: 221,
		country_iso: "US",
		prefix: "1",
		created_at: "2020-05-21T14:07:50.823365",
		updated_at: null,
		deleted: false,
	},
	{
		id: 459,
		country_iso: "CA",
		prefix: "1",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 152,
		country_iso: "NG",
		prefix: "234",
		created_at: "2020-05-21T14:07:50.823365",
		updated_at: null,
		deleted: false,
	},
	{
		id: 474,
		country_iso: "ZA",
		prefix: "27",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 462,
		country_iso: "FR",
		prefix: "33",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 166,
		country_iso: "PT",
		prefix: "351",
		created_at: "2020-05-21T14:07:50.823365",
		updated_at: null,
		deleted: false,
	},
	{
		id: 467,
		country_iso: "IT",
		prefix: "39",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 54,
		country_iso: "CZ",
		prefix: "420",
		created_at: "2020-05-21T14:07:50.823365",
		updated_at: null,
		deleted: false,
	},
	{
		id: 463,
		country_iso: "GB",
		prefix: "44",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 165,
		country_iso: "PL",
		prefix: "48",
		created_at: "2020-05-21T14:07:50.823365",
		updated_at: null,
		deleted: false,
	},
	{
		id: 461,
		country_iso: "DE",
		prefix: "49",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 470,
		country_iso: "MX",
		prefix: "52",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 456,
		country_iso: "AR",
		prefix: "54",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 458,
		country_iso: "BR",
		prefix: "55",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 457,
		country_iso: "AU",
		prefix: "61",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 464,
		country_iso: "ID",
		prefix: "62",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 471,
		country_iso: "RU",
		prefix: "7",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 468,
		country_iso: "JP",
		prefix: "81",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 469,
		country_iso: "KR",
		prefix: "82",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 460,
		country_iso: "CN",
		prefix: "86",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 473,
		country_iso: "TR",
		prefix: "90",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 466,
		country_iso: "IN",
		prefix: "91",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
	{
		id: 472,
		country_iso: "SA",
		prefix: "966",
		created_at: "2020-06-29T09:39:10.890995",
		updated_at: null,
		deleted: false,
	},
]

export default PHONE_PREFIXES
